import { INotificationList } from './../types/PushNotificationType'
import http from '../core/http-common'
import { INotificationRequest, IReadResult } from '../types/PushNotificationType'

class PushNotificationService {
  GetNotifications(request: INotificationRequest) {
    return http.get<INotificationList>(
      `NotificationHistory/GetNotifications?pageSize=${request.pageSize}&pageNumber=${request.pageNumber}`
    )
  }
  ReadNotification(id: number) {
    return http.post<IReadResult>(`NotificationHistory/Read?id=${id}`)
  }
  ReadAll() {
    return http.post<IReadResult>(`NotificationHistory/ReadAll`)
  }
  GetUnreadNotifications() {
    return http.get(`/NotificationHistory/GetUnreadNotificationCount`)
  }
}
export default new PushNotificationService()
